import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Node} from '../model/treeview/node';
@Component({
selector:'context-menu',
  template:`
  <ul type="context" id="menu" [ngStyle]="{'top.px':top,'left.px':left}">
    <li *ngIf="!emailComposer" label="Import" (click)="onImport()"></li>
      <li *ngIf="emailComposer && node.getName()==='Email'" label="New Folder" (click)="onNewFolder()"></li>
      <li *ngIf="emailComposer && (node.getName()==='Templates' && node.getNodeList().length===0)" label="Create Email Root " (click)="onNewFolder()"></li>
      <li *ngIf="emailComposer && (node.getName()!=='Templates' && node.getName()!=='Email')" label="New Email Template" (click)="onNewEmailTemplate()"></li>
    <li label="Open in Dashboard…"></li>
    <hr>
    <li label="Show Page Source"></li>
    <li label="Save Page As…"></li>
    <li label="Print Page…"></li>
    <hr>
    <li label="Menu explorer"></li>
    <hr>
    <li label="Inspect Element"></li>
  </ul>
  `,
  styles:[`
    li {font-weight: bold; font-family: Helvetica;font-size: small;}
    #target {
      background: #cad;
      border: 1px solid black;
      width: 100px;
      height: 100px;
    }

    ul {
      display: block;
      position: absolute;

      margin: 0;
      padding: 3px 0 4px;

      background: rgba(255, 255, 255, 0.95);
      box-shadow: 0 8px 15px rgba(0, 0, 0, 0.35);
      border-radius: 4px;

      font-family: Lucida Grande;
      font-size: 14px;
      line-height: 15px;
    }

    ul::before {
      display: block;
      position: absolute;
      content: "";
      top: -1px;
      left: -1px;
      bottom: -1px;
      right: -1px;

      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.125);
      z-index: -1;
    }

    ul hr {
      border: none;
      height: 1px;
      background: rgba(0, 0, 0, 0.10);
      margin: 6px 1px 5px;
      padding: 0;
    }

    ul li {
      display: block;
      padding: 0 20px;
      border-top: 1px solid rgba(0, 0, 0, 0);
      border-bottom: 1px solid rgba(0, 0, 0, 0);
    }

    ul li::after {
      vertical-align: 2px;
      content: attr(label);
    }

    ul li:hover {
      background: -webkit-linear-gradient(top, #648bf5, #2866f2);
      background: linear-gradient(to bottom, #648bf5 0%, #2866f2 100%);
      border-top: 1px solid #5a82eb;
      border-bottom: 1px solid #1758e7;
    }

    ul li:hover:after{
      color: #ffffff;
    }

  `]
})

export class ContextMenuComponent {

   @Input() emailComposer =  false;
   @Input() createTemplate = false;
   @Input() node:Node;

   @Input() top:number;
   @Input() left:number;
   @Output() import:EventEmitter<any> = new EventEmitter<any>();

   @Output() newFolder:EventEmitter<any> = new EventEmitter<any>();
    @Output() newEmailTemplate:EventEmitter<any> = new EventEmitter<any>();

  constructor() {

  }

  /*public setCoordinates(top:number,left:number) {
    this._top = top.toString();
    this._left= left.toString();
  }*/

  public toggle() {
    // this.hide = !this.hide;
  }

 /* private getTop() {
    return this._top;
  }

  private getLeft() {
    return this._left;
  }*/
  onImport() {
    this.import.emit();
  }

  onNewFolder() {
    this.newFolder.emit();
  }

    onNewEmailTemplate() {
        this.newEmailTemplate.emit();
    }
}
